import { addCommand, addCommandCallback } from '../utils';
const localpreferences = {
    nonpersistent: {
        set: function (params) {
            addCommand('median://localpreferences/nonpersistent/set', params);
        },
        get: function (params) {
            return addCommandCallback('median://localpreferences/nonpersistent/get', params);
        },
        delete: function (params) {
            addCommand('median://localpreferences/nonpersistent/delete', params);
        },
        deleteAll: function (params) {
            addCommand('median://localpreferences/nonpersistent/deleteAll', params);
        },
    },
    persistent: {
        set: function (params) {
            addCommand('median://localpreferences/persistent/set', params);
        },
        get: function (params) {
            return addCommandCallback('median://localpreferences/persistent/get', params);
        },
        delete: function (params) {
            addCommand('median://localpreferences/persistent/delete', params);
        },
        deleteAll: function (params) {
            addCommand('median://localpreferences/persistent/deleteAll', params);
        },
    },
    filesystem: {
        save: function (params) {
            addCommand('median://localpreferences/filesystem/save', params);
        },
        read: function (params) {
            return addCommandCallback('median://localpreferences/filesystem/read', params);
        },
        delete: function (params) {
            addCommand('median://localpreferences/filesystem/delete', params);
        },
    },
    keychain: {
        set: function (params) {
            return addCommandCallback('median://localpreferences/keychain/set', params);
        },
        get: function (params) {
            return addCommandCallback('median://localpreferences/keychain/get', params);
        },
        delete: function (params) {
            return addCommandCallback('median://localpreferences/keychain/delete', params);
        },
        deleteAll: function (params) {
            return addCommandCallback('median://localpreferences/keychain/deleteAll', params);
        },
    },
};
export default localpreferences;
